import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ApiResponse } from '../shared/model/response-format';
import { Admin, hr } from '../shared/model/admin-user-dto';
import { AssessmentDto } from '../shared/model/assessment-dto';
import { AlterStatusRequestDto } from '../shared/model/alter-status-request-dto';
import {
  newQuestionDto,
} from '../shared/model/newQuestion-dto';
import { environment } from 'src/environments/environment';
import { AppClient } from 'src/environments/client';
import { LoggedInUserKeys, LoggedInUserService } from '../shared/service/logged-in-user.service';
import { AppUsersDto } from '../shared/model/app-users-dto';
import { DOMAIN_CONFIG } from 'domain-config';


@Injectable({
  providedIn: 'root',
})
export class AdminService {
  deployedClient = environment.deployedClient;
  baseUrl = environment.baseUrl;
  videoMerge = environment.videoMergeFeed;
  gpuUrl = environment.gpuProctoringUrl;
  gpuQueueUrl = environment.gpuQueueStatusUrl;
  videoProctoringMachineId = environment.videoProctoringMachineId;
  apiUrls = {
    adminSignIn: '/api/v1/auth/iqigai/user-login',
    saveAssessment: '/api/v1/user/save-assessment',
    // getAssessmentDetails: "/api/v1/user/get-assessment",
    getUserData: '/api/v1/user/get-hr-data',
    addUpdateUser: '/api/v1/user/create-or-edit-hr',
    saveUserAlterStatus: '/api/v1/user/alter-status',
    changePassword: '/api/v1/user/change-password',
    candidateChangePassword: '/api/v1/user/candidate-change-password',
    saveBulkUpload: '/api/v1/user/upload-in-bulk',
    resetPassword: '/api/v1/user/reset-password/',
    downloadExcelSheet: '/api/v1/reports/user/sample-add-hr-excel',
    addNewQuestion: '/api/v1/master-new-question/add-question',
    getAllQuestion: '/api/v1/master-new-question/get-all-master-new-questions',
    getQuestionById: '/api/v1/master-new-question/get-question-by-id/',
    getAllGroups: '/api/v1/master-new-question/get-all-group',
    createGroup: '/api/v1/master-new-question/create-group',
    getQuestionByGroupId:
      '/api/v1/master-new-question/get-all-question-by-group',
    removeQuestionFromGroup:
      '/api/v1/master-new-question/remove-question-from-group/',
    getLinkGroupQuestion:
      '/api/v1/master-new-question/get-questions-for-link-group',
    addQuestionToGroup: '/api/v1/master-new-question/add-group-to-question',
    collegeAdminSignIn: '/api/v1/user/create-college-admin',
    getAllCollegeAdminDrives:
      '/api/v1/drive-config/get-all-drives-of-college-admin',
    getCandidatesByDriveId: '/api/v1/drive-config/get-candidates-by-drive',
    approveRejectCandidate: '/api/v1/drive-config/reject-or-approve-candidate/',
    getGroupById: '/api/v1/master-new-question/get-group-by-id/',
    deleteGroupById: '/api/v1/master-new-question/delete-group/',
    getQuestionReport: '/api/v1/report-question/get-all-reports',
    generateReportedQuestionsReport:
      '/api/v1/report-question/generate-all-question-report-in-excel',
    downloadReportedQuestionsReport:
      '/api/v1/report-question/download-all-question-report-in-excel',
    getManualQuestions: '/api/v1/drive-config/get-questions-for-manual-flow',
    getAllQuestionsBySubcategory:
      '/api/v1/assessment-config/get-all-questions-by-subcategory',
    getAllGroupData: '/api/v1/assessment-config/get-all-groups',
    deleteByGroupId: '/api/v1/assessment-config/delete-group/',
    ServerHealthCheck: '/api/v1/health-indicator/check',
    videoProctoringMachineStart: '/videoProctoringMachineStart',
    videoProctoringMachineStop: '/videoProctoringMachineStop',
    videoProctoringServerStatusPolling: '/videoProctoringServerStatusPolling',
    videoProctoringQueueStatus: '/queue-status'
  };
  constructor(
    private readonly _http: HttpClient,
    private readonly _loggedInUserService: LoggedInUserService
  ) {}

  isProctoringServerAllowed(): boolean {
    const domainConfig = DOMAIN_CONFIG[window.location.hostname];
    if (!domainConfig?.proctoringServerEnabled) return false;

    const allowedEmails: string[] = domainConfig.proctoringAllowedEmails || [];
    if (!allowedEmails.length) return false;

    const loggedInUser: AppUsersDto = this._loggedInUserService.getLoggedInUser(
      LoggedInUserKeys.LOGGED_IN_USER
    );
    const email = loggedInUser?.email?.trim().toLowerCase();
    if (!email) return false;

    return allowedEmails.some(
      (allowed) => allowed.trim().toLowerCase() === email
    );
  }


  signInAdmin(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.adminSignIn,
      requestPayload
    );
  }

  addUpdateUser(requestPayload: Admin): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.addUpdateUser,
      requestPayload
    );
  }

  saveUserAlterStatus(
    requestPayload: AlterStatusRequestDto
  ): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.saveUserAlterStatus,
      requestPayload
    );
  }

  getUserData(requestPayload): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getUserData,
      requestPayload
    );
  }

  saveAssessmentDetails(
    requestPayload: AssessmentDto
  ): Observable<ApiResponse<AssessmentDto>> {
    return this._http.post<ApiResponse<AssessmentDto>>(
      this.baseUrl + this.apiUrls.saveAssessment,
      requestPayload
    );
  }

  saveBulkUpload(requestPayload: FormData): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.saveBulkUpload,
      requestPayload
    );
  }

  downloadExecl(): Observable<ApiResponse<any>> {
    let url = this.baseUrl;
    if(this.deployedClient == AppClient.PROD_MAIN || this.deployedClient == AppClient.PROD_LITE){
      url = this.videoMerge;
    }
    return this._http.get<ApiResponse<any>>(
      url + this.apiUrls.downloadExcelSheet
    );
  }

  changePassword(requestPayload: hr): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.changePassword,
      requestPayload
    );
  }

  resetPassword(id: string): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.resetPassword + id,
      id
    );
  }

  addNewQuestion(requestPayload: newQuestionDto): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.addNewQuestion,
      requestPayload
    );
  }

  getAllQuestion(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllQuestion,
      requestPayload
    );
  }

  getQuestionById(questionId): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getQuestionById + questionId
    );
  }

  getAllGroups(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllGroups,
      requestPayload
    );
  }

  createGroup(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.createGroup,
      requestPayload
    );
  }

  getQuestionByGroupId(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getQuestionByGroupId,
      requestPayload
    );
  }

  removeQuestionFromGroup(groupId, questionId): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl +
        this.apiUrls.removeQuestionFromGroup +
        groupId +
        '/' +
        questionId
    );
  }

  getLinkGroupQuestion(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getLinkGroupQuestion,
      requestPayload
    );
  }

  addQuestionToGroup(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.addQuestionToGroup,
      requestPayload
    );
  }

  signInCollegeAdmin(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.collegeAdminSignIn,
      requestPayload
    );
  }

  getAllCollegeAdminDrives(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllCollegeAdminDrives,
      requestPayload
    );
  }

  getCandidatesByDriveId(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getCandidatesByDriveId,
      requestPayload
    );
  }

  approveRejectCandidate(
    candidateId,
    requestType
  ): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl +
        this.apiUrls.approveRejectCandidate +
        candidateId +
        '/' +
        requestType
    );
  }

  getGroupById(groupId): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getGroupById + groupId
    );
  }

  deleteGroupById(groupId): Observable<ApiResponse<any>> {
    return this._http.delete<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.deleteGroupById + groupId
    );
  }

  getQuestionReport(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getQuestionReport,
      requestPayload
    );
  }

  generateReportedQuestionsReport(): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.generateReportedQuestionsReport
    );
  }

  downloadReportedQuestionsReport(): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.downloadReportedQuestionsReport
    );
  }

  getManualQuestions(requestPayload: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getManualQuestions,
      requestPayload
    );
  }

  getAllQuestionsBySubcategory(
    requestPayload: any
  ): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllQuestionsBySubcategory,
      requestPayload
    );
  }
  getAllGroupData(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.getAllGroupData,
      requestPayload
    );
  }
  deleteGroup(groupId): Observable<ApiResponse<any>> {
    return this._http.delete<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.deleteByGroupId + groupId
    );
  }

   ServerHealthCheck(): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.ServerHealthCheck,
      {
        headers: { 'X-API-KEY': '2d02dbae65d8277f1318bacea3605c53bd778cea' }
      }
    );
  }

  private get videoProctoringPayload() {
    return { id: this.videoProctoringMachineId };
  }

  private get videoProctoringOptions() {
    return { headers: { 'X-Skip-Error-Interceptor': 'true' } };
  }

  private guardVideoProctoringHost(): Observable<never> | null {
    if (this.isProctoringServerAllowed()) return null;
    return throwError(() => ({
      error: {
        message: 'Proctoring server controls are not available for this account.'
      }
    }));
  }

  startVideoProctoringMachine(): Observable<any> {
    return this.guardVideoProctoringHost() ?? this._http.post<any>(
      this.gpuUrl + this.apiUrls.videoProctoringMachineStart,
      this.videoProctoringPayload,
      this.videoProctoringOptions
    );
  }

  stopVideoProctoringMachine(): Observable<any> {
    return this.guardVideoProctoringHost() ?? this._http.post<any>(
      this.gpuUrl + this.apiUrls.videoProctoringMachineStop,
      this.videoProctoringPayload,
      this.videoProctoringOptions
    );
  }

  getVideoProctoringServerStatus(): Observable<any> {
    return this.guardVideoProctoringHost() ?? this._http.post<any>(
      this.gpuUrl + this.apiUrls.videoProctoringServerStatusPolling,
      this.videoProctoringPayload,
      this.videoProctoringOptions
    );
  }

  getVideoProctoringQueueStatus(): Observable<any> {
    return this.guardVideoProctoringHost() ?? this._http.post<any>(
      this.gpuQueueUrl + this.apiUrls.videoProctoringQueueStatus,
      this.videoProctoringPayload,
      this.videoProctoringOptions
    );
  }

   candidateChangePassword(requestPayload: hr): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.candidateChangePassword,
      requestPayload
    );
  }

}
